import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/models/root-state.model';
import { selectTagsLoaded, selectUserSpecificTag } from '@/store/selectors/userSelectors';

const AB_MARKET_TAG = 'market::ca-ab';
const AB_REDIRECT_URL = 'https://luckydays.ca/ab';

const selectHasAbMarketTag = selectUserSpecificTag(AB_MARKET_TAG);

// Alberta (CA) market users must land on the dedicated /ab experience on every
// authenticated session. Both fresh login and auto-login funnel through the user
// tags fetch, so keying on `tagsLoaded` covers them without any special-casing.
const useMarketRedirect = (): void => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.token !== null);
  const tagsLoaded = useSelector(selectTagsLoaded);
  const hasAbMarketTag = useSelector(selectHasAbMarketTag);

  useEffect(() => {
    if (!isAuthenticated || !tagsLoaded || !hasAbMarketTag) {
      return;
    }

    // Loop guard: the redirect is a hard full-page navigation to the target, so
    // once we have already landed there, stop redirecting.
    const isOnAbTarget =
      window.location.origin === 'https://luckydays.ca' &&
      window.location.pathname.startsWith('/ab');

    if (isOnAbTarget) {
      return;
    }

    window.location.replace(AB_REDIRECT_URL);
  }, [isAuthenticated, tagsLoaded, hasAbMarketTag]);
};

export default useMarketRedirect;
